var c = {
    AREA: 17469,
    PRICE_PER_M2: 10
};
export default c;
//# sourceMappingURL=zevenster-area-constants.js.map